import { Box, TextField, Typography } from '@mui/material';

interface SaveReportFormProps {
    name: string;
    description: string;
    onNameChange: (name: string) => void;
    onDescriptionChange: (description: string) => void;
    /** Named only when updating, to say which saved copy is about to be replaced. */
    replacingReportName?: string;
}

export default function SaveReportForm({
    name,
    description,
    onNameChange,
    onDescriptionChange,
    replacingReportName,
}: SaveReportFormProps) {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
            <TextField
                label='Report Name'
                value={name}
                onChange={(e) => onNameChange(e.target.value)}
                required
                autoFocus
                fullWidth
            />
            <TextField
                label='Description (optional)'
                value={description}
                onChange={(e) => onDescriptionChange(e.target.value)}
                multiline
                rows={3}
                fullWidth
            />
            {replacingReportName && (
                <Typography variant='body2' color='text.secondary'>
                    This replaces the saved copy of <strong>{replacingReportName}</strong> with your
                    current filter and grid layout.
                </Typography>
            )}
        </Box>
    );
}
